<template>
  <div>
    <div v-for="(category, cIndex) in categories" :key="cIndex" class="py-1 mx-1">
      <div header-tag="header" class="p-1" role="tab">
            <b-button
            :id="`${cIndex}CAT${borrowerId}`"
              v-b-toggle="`accordion-cat${cIndex}${borrowerId}`"
              block
              class="d-flex collapseSubHeader"
              @click="isVisibleCategory = !isVisibleCategory"
            >
              <p class="mb-0 text-dark font-weight-bolder"
                >{{ category[0].propertyOwnershipCategory }} ({{ category.length }})</p
              >
              <strong class="ml-auto"
                ><i
                  :class="`fa fa-angle-${isVisibleCategory ? 'up' : 'down'
                    } text-dark`
                    "
                ></i
              ></strong>
            </b-button>
      </div>
      <b-collapse :id="`accordion-cat${cIndex}${borrowerId}`" visible>
        <div v-if="isListEmpty(category).length">
      <div v-for="(item, ind) in category" :key="ind" class="baseContentFont mx-1 my-2 py-1 border">
          <b-row class="mx-1 my-1">
            <b-col md="9"><div><b>{{ item.propertyAddresses.streetAddress }}</b></div><div><b>{{ item.propertyAddresses.stateCityZip }}</b></div></b-col>
            <b-col><div><b>County: </b>{{ item.propertyAddresses.county }}</div><div><b>APN: </b>{{ item.propertyAddresses.apn }}</div></b-col>
          </b-row>

          <div class="mx-3 my-3 border py-1">
          <b-row class="mx-1">
            <b-col><b>Recording Date - Deed: </b>{{ item.propertyGrid.deedRecordingDate }}</b-col>
            <b-col><b>Year Built: </b>{{ item.propertyGrid.yearBuilt }}</b-col>
            <b-col><b>Recording Date - Assessor: </b>{{ item.propertyGrid.assessmentRecordingDate }}</b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col><b>Contract Date: </b>{{ item.propertyGrid.contractDate }}</b-col>
            <b-col><b>Land Use: </b>{{ item.propertyGrid.landUsage }}</b-col>
            <b-col><b>Tax Year: </b>{{ item.propertyGrid.taxYear }}</b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col><b>Sale Price: </b>{{ item.propertyGrid.salePrice }}</b-col>
            <b-col><b>GLA/Lot: </b>{{ item.propertyGrid.sqFtLot }}</b-col>
            <b-col><b>Tax Amount - Assessor: </b>{{ item.propertyGrid.taxAmount }}</b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col><b>Loan Amount: </b>{{ item.propertyGrid.loanAmount }}</b-col>
            <b-col><b>Bed/Bath: </b>{{ item.propertyGrid.bedBath }}</b-col>
            <b-col><b>Tax Exemption: </b>{{ item.propertyGrid.taxExemption }}</b-col>
          </b-row>
          </div>
          <!-- Deed Records -->
          <b-row class="mx-1">
            <b-col><BaseELabel label="Deed Records" class="mb-2" new-style /></b-col>
          </b-row>
          <b-row  class="mx-1">
            <b-col>
              <b-table
                bordered
                responsive
                striped
                thead-tr-class="d-none"
                :tbody-tr-class="!isListEmpty(item.propertyDeed).length ? 'd-none' : ''"
                :fields="deedFields"
                :items="isListEmpty(item.propertyDeed)"
                class="mb-0 fraudReportHeaderTable"
              >
              <template v-slot:thead-top="">
              <b-tr>
                <b-th rowspan="2" class="text-right" style="width: 8.5%">Recording Date</b-th>
                <b-th rowspan="1" style="width: 10%">Document Type</b-th>
                <b-th rowspan="2" style="width: 15.5%">Lender Name</b-th>
                <b-th rowspan="1" style="width: 10%">Transaction Type</b-th>
                <b-th rowspan="2" style="width: 10%">Loan Type</b-th>
                <b-th rowspan="1" style="width: 23%">Buyer Name</b-th>
                <b-th rowspan="1" style="width: 23%">Seller Name</b-th>
              </b-tr>
              <b-tr>
                <b-th style="width: 10%">Document Number</b-th>
                <b-th style="width: 10%">Loan Amount</b-th>
                <b-th style="width: 23%">Buyer Address</b-th>
                <b-th style="width: 23%">Seller Address</b-th>
              </b-tr>
              </template>
              <template v-slot:cell(documentType)="rowitem">
                <div class="textTruncatee py-2">{{ rowitem.item.documentType }}</div>
                <div class="ownershipStretch"></div>
                <div class="textTruncatee py-2">{{ rowitem.item.documentNumber }}</div>
              </template>
              <template v-slot:cell(transactionType)="rowitem">
                <div class="textTruncatee py-2">{{ rowitem.item.transactionType }}</div>
                <div class="ownershipStretch"></div>
                <div class="textTruncatee py-2">{{ rowitem.item.loanAmount }}</div>
              </template>
              <template v-slot:cell(loanType)="rowitem">
                <div class="textTruncatee py-2">{{ rowitem.item.loanType }}</div>
              </template>
              <template v-slot:cell(buyerName)="rowitem">
                <div class="py-2"><div v-for="(buyer, i) in isListEmpty(rowitem.item.buyerName)" :key="i" class="textTruncatee">{{ buyer }}</div></div>
                <div class="ownershipStretch"></div>
                <div class="textTruncatee py-2">{{ rowitem.item.buyerAddress }}</div>
              </template>
              <template v-slot:cell(sellerName)="rowitem">
                <div class="py-2"><div v-for="(seller, j) in isListEmpty(rowitem.item.sellerName)" :key="j" class="textTruncatee">{{ seller }}</div></div>
                <div class="ownershipStretch"></div>
                <div class="textTruncatee py-2">{{ rowitem.item.sellerAddress }}</div>
              </template>
          </b-table>
            <NoRecordFound v-if="!isListEmpty(item.propertyDeed).length"></NoRecordFound>
            </b-col>
          </b-row>
          <!-- Tax Records -->
          <b-row class="mx-1 pt-3">
            <b-col><BaseELabel label="Assessor Records" class="mb-2" new-style /></b-col>
          </b-row>
          <b-row class="mx-1 pb-3">
            <b-col>
              <b-table
              bordered
              responsive
              striped
              :fields="taxFields"
              :items="isListEmpty(item.propertyTax)"
              class="mb-0 fraudReportHeaderTable"
            >
            <template v-slot:cell(ownerName)="rowitem">
                <div v-for="(owner, k) in isListEmpty(rowitem.item.ownerName)" :key="k" class="textTruncatee">{{ owner }}</div>
              </template>
            </b-table>
            <NoRecordFound v-if="!isListEmpty(item.propertyTax).length"></NoRecordFound>
            </b-col>
          </b-row>
      </div>
        </div>
      </b-collapse>
    </div>

    <NoRecordFound v-if="!categories.length" class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    propertyData: {
      type: Array,
      default: () => [],
    },
    borrowerId:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      deedFields: [
        {
          key: 'deedRecordingDate',
          label: 'Recording Date - Deed',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',thStyle: { width: '8.5%' }
        },
        {
          key: 'documentType',
          label: 'Document Type',
        },
        {
          key: 'lenderName',
          label: 'Lender Name',
          class: 'textTruncatee',
        },
        {
          key: 'transactionType',
          label: 'Transaction Type',
        },
        {
          key: 'loanType',
          label: 'Loan Type',
        },
        {
          key: 'buyerName',
          label: 'Buyer Name',
        },
        {
          key: 'sellerName',
          label: 'Seller Name',
        },
      ],
      taxFields: [
        {
          key: 'taxYear',
          label: 'Tax Year',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',thStyle: { width: '6%' }
        },
        {
          key: 'assesseeRecordingDate',
          label: 'Recording Date',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',thStyle: { width: '10%' }
        },
        {
          key: 'ownerName',
          label: 'Owner Name',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '20%' }
        },
        {
          key: 'ownerAddress',
          label: 'Owner Address',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '25%' }
        },
        {
          key: 'legalDescription',
          label: 'Brief Legal Description',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '25%' }
        },
        {
          key: 'totalValue',
          label: 'Total Market Value',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',thStyle: { width: '15%' }
        },
      ],
      isVisibleCategory: true,
    }
  },
  computed: {
    categories(){
      const sortedProperties = [...this.propertyData].sort(this.ownershipSorting);
      return Object.values(
        Object.groupBy(sortedProperties, p => p.propertyOwnershipCategory ))
    },
  },
  methods: {
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
    ownershipSorting(a, b){
      const order = {"Currently Owned": 0, "Possibly Owned": 1, "Prior Owned": 2};
      return order[a.propertyOwnershipCategory] - order[b.propertyOwnershipCategory];
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
.collapseSubHeader {
  background-color: $color-raisin-40 !important;
  border: none;
}

.ownershipStretch {
  margin: 0 -20px;
  border-bottom: 1px solid #dee2e6;
}
</style>
